// Página "Cargando" (próximamente) QLK Fest 2026 · 2da edición.
// Imagen a pantalla completa + zonas clickeables sobre Instagram y TikTok.
import React, { useEffect, useState } from 'react';

import FondoDesktop from '../assets/Cargando/qlk26-horizontal.jpg'; // 1920x1081
import FondoMobile from '../assets/Cargando/qlk26-vertical.jpg'; // 1081x1921
import MaskDesktop from '../assets/Cargando/qlk26-marq-mask-h.png';
import MaskMobile from '../assets/Cargando/qlk26-marq-mask-v.png';
import Marquesina from '../assets/qlk26/v2/marquesina-tile.png'; // 1438x74, se repite sin corte

const INSTAGRAM_URL = 'https://www.instagram.com/qlkfest/';
const TIKTOK_URL = 'https://www.tiktok.com/@qlkfest';

// Posición de cada botón en % de la imagen: [left, top, width, height]
// band: franja rosa en px de la imagen [top, bottom]; mask tapa la parte del logo.
const LAYOUT = {
  desktop: {
    img: FondoDesktop,
    w: 1920,
    h: 1081,
    ratio: 1920 / 1081,
    band: [466, 538],
    mask: MaskDesktop,
    ig: [58.5, 86.5, 12, 7],
    tiktok: [73.3, 86.5, 11.5, 7],
  },
  mobile: {
    img: FondoMobile,
    w: 1081,
    h: 1921,
    ratio: 1081 / 1921,
    band: [413, 485],
    mask: MaskMobile,
    ig: [26.5, 74.2, 21.5, 3.6],
    tiktok: [52.8, 74.2, 21, 3.6],
  },
};

const MARQUEE_CSS = `
.cargando-marquee-track {
  display: flex;
  height: 100%;
  width: max-content;
  animation: cargando-scroll 30s linear infinite;
}
.cargando-marquee-track img {
  height: 100%;
  width: auto;
  flex: none;
  display: block;
}
/* 4 copias del mosaico: desplazar 1 copia = loop sin corte */
@keyframes cargando-scroll {
  from { transform: translateX(0); }
  to { transform: translateX(-25%); }
}
@media (prefers-reduced-motion: reduce) {
  .cargando-marquee-track { animation-duration: 120s; }
}
`;

const viewport = () => ({ w: window.innerWidth, h: window.innerHeight });

export default function Cargando() {
  const [vp, setVp] = useState(viewport());

  useEffect(() => {
    const onResize = () => setVp(viewport());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const aspect = vp.w / vp.h;
  const l = aspect >= 1 ? LAYOUT.desktop : LAYOUT.mobile;

  // Cómo entra la imagen en la pantalla:
  // - pantalla un poco más angosta que la imagen (hasta 25%): la cubre entera y
  //   recorta solo los costados (nunca abajo, donde están produce y redes).
  // - pantalla un poco más ancha (hasta ~2:1, notebooks con el navegador abierto):
  //   a sangre, recortando hasta 6% arriba y 6% abajo (margen libre de la imagen:
  //   el logo empieza ~8% y las redes terminan ~94%).
  // - pantalla mucho más ancha o mucho más angosta: se ve la imagen completa y el
  //   resto se rellena con la misma foto desenfocada.
  const MAX_VCROP = 0.12;
  const coverSides = aspect <= l.ratio && aspect >= l.ratio * 0.75;
  const coverTopBottom = aspect > l.ratio && aspect <= l.ratio / (1 - MAX_VCROP);
  let stageW;
  if (coverSides) stageW = vp.h * l.ratio;
  else if (coverTopBottom) stageW = vp.w;
  else stageW = Math.min(vp.w, vp.h * l.ratio);
  const stageH = stageW / l.ratio;

  // Los botones se posicionan en % sobre la imagen, así siempre quedan en su lugar.
  const stage = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: `${stageW}px`,
    height: `${stageH}px`,
  };

  const hotspot = ([left, top, width, height]) => ({
    position: 'absolute',
    left: `${left}%`,
    top: `${top}%`,
    width: `${width}%`,
    height: `${height}%`,
    display: 'block',
    borderRadius: 8,
  });

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        background: '#201f1f',
      }}
    >
      {/* relleno: la misma imagen desenfocada detrás, para que no queden franjas negras */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: '-40px',
          backgroundImage: `url(${l.img})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(28px) brightness(0.55)',
        }}
      />
      <div style={stage}>
        <img
          src={l.img}
          alt="QLK Fest 2da edición · Una noche nos quedaba corta · Río Cuarto - Córdoba"
          style={{ width: '100%', height: '100%', display: 'block' }}
        />
        {/* Marquesina en movimiento sobre la franja rosa; la máscara deja el logo por encima */}
        <style>{MARQUEE_CSS}</style>
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: 0,
            width: '100%',
            top: `${(l.band[0] / l.h) * 100}%`,
            height: `${((l.band[1] - l.band[0]) / l.h) * 100}%`,
            overflow: 'hidden',
            background: '#fc60a8',
            WebkitMaskImage: `url(${l.mask})`,
            maskImage: `url(${l.mask})`,
            WebkitMaskSize: '100% 100%',
            maskSize: '100% 100%',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
          }}
        >
          <div className="cargando-marquee-track">
            {[0, 1, 2, 3].map((i) => (
              <img key={i} src={Marquesina} alt="" />
            ))}
          </div>
        </div>
        <a
          className="cargando-social"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram @qlkfest"
          style={hotspot(l.ig)}
        />
        <a
          className="cargando-social"
          href={TIKTOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TikTok @qlkfest"
          style={hotspot(l.tiktok)}
        />
      </div>
    </div>
  );
}
